import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoginManager } from '../../core/login-manager';



export default function HeaderHook() {

    const [blocked, setBlocked] = useState(false);

    useEffect(() => {
        const userInfo = LoginManager.getUserInfo();
        if (userInfo && Number(userInfo.level) === 2) {
            setBlocked(true);
            LoginManager.logout();
        }
    }, []);



    return (
        <>
            {blocked && (
                <div
                    style={{
                        position: 'fixed',
                        inset: 0,
                        zIndex: 9999,
                        backgroundColor: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '1rem'
                    }}
                >
                    <div
                        style={{
                            maxWidth: 480,
                            textAlign: 'center'
                        }}
                    >
                        <FontAwesomeIcon
                            icon='triangle-exclamation'
                            style={{ fontSize: '3rem', color: '#dc3545', marginBottom: '1rem' }}
                        />
                        <h4 style={{ marginBottom: '0.75rem' }}>Accesso non consentito</h4>
                        <p style={{ marginBottom: '1.5rem', color: '#6c757d' }}>
                            Questo portale è riservato agli operatori. Usa l'area candidati per accedere.
                        </p>
                        <Spinner animation='border' role='status' size='sm' />
                    </div>
                </div>
            )}
        </>
    )
};
